// « Restitué le 14/08 » / « En intervention depuis aujourd'hui » — le libellé
// « depuis quand » d'un statut atelier, PARTAGÉ.
//
// Né dans la modale d'intervention (2026-08-15), aussitôt demandé dans Gestion
// Parking : deux copies auraient divergé sur la première nuance (même
// raisonnement que utils/cravate.js et planning/TriTableau.js).
//
// Règles :
//  - « le » pour un statut ponctuel ou final (Restitué, Facturé, … terminé) ;
//    « depuis le » pour un état qui dure — c'est la durée qui alerte.
//    L'heuristique porte sur le NOM : le référentiel `statuts_atelier` est
//    configurable par concession, des ids codés en dur ne survivraient pas.
//  - « aujourd'hui » remplace la date du jour (sans « le »).
//  - année ajoutée en 2 chiffres seulement quand elle diffère de l'année
//    courante.
//  - « ~ » devant la date quand elle est APPROCHÉE (`statut_atelier_since_estime`,
//    reprise d'`updated_at` à la migration du 2026-08-14) — même convention que
//    les notifications et la vue Tableaux.

export function libelleStatutDepuis(nomStatut, sinceIso, estime = false) {
  if (!nomStatut || !sinceIso) return '';
  const d = new Date(sinceIso);
  if (Number.isNaN(d.getTime())) return '';
  const auj = new Date();
  const tilde = estime ? '~' : '';
  const ponctuel = /(restitué|facturé|terminée?)\s*$/i.test(nomStatut);
  if (d.toDateString() === auj.toDateString()) {
    return ponctuel ? `${tilde}aujourd'hui` : `depuis ${tilde}aujourd'hui`;
  }
  const jour = d.toLocaleDateString('fr-FR',
    d.getFullYear() === auj.getFullYear()
      ? { day: '2-digit', month: '2-digit' }
      : { day: '2-digit', month: '2-digit', year: '2-digit' });
  return `${ponctuel ? 'le ' : 'depuis le '}${tilde}${jour}`;
}

export default libelleStatutDepuis;
